import { GetGroupsFilter } from "@syla/shared/types/requests/GetGroupsRequest";
import { OrderFilterSetting } from "../../types/order/orderQuery";

export function filterToFilterParams({
  asset,
  dataSource,
  dateRange,
  ledgerType,
  searchQuery,
  status,
  transactionType,
  imports,
}: OrderFilterSetting): GetGroupsFilter {
  return {
    asset: asset.length ? asset : undefined,
    dataSource: dataSource.length ? dataSource : undefined,
    transactionType: transactionType.length ? transactionType : undefined,
    ledgerType: ledgerType.length ? ledgerType : undefined,
    datePeriod:
      dateRange && dateRange[0] && dateRange[1] ?
        [dateRange[0], dateRange[1]]
      : undefined,
    searchQuery: searchQuery || undefined, // don't pass in the search query if it is an empty string
    status: status.length ? status : undefined,
    imports,
  };
}
